import {theme as findhotel} from './findhotel'
import {theme as v2} from './v2'

export enum Themes {
  findhotel = 'findhotel',
  v2 = 'v2'
}

const getTheme = (theme?: Themes) => {
  if (theme === Themes.v2) return v2

  return findhotel
}

export {getTheme}
